// Zentralise date formatting to ensure consistency
import moment from 'moment';
import I18n from '../config/i18n';

// moment.updateLocale('de', {
//   monthsShort: ['Jan', 'Feb',
// 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
// });

export const formatDate = (date: Date | moment.Moment | string): string =>
  moment(date).locale(moment.locale()).format(I18n.t('date.formats.request_time_scope'));

export const formatDateMonthShort = (date: Date | moment.Moment | string): string =>
  moment(date).locale(moment.locale()).format(I18n.t('date.formats.day_date_month'));

export const formatDateMonthYear = (date: Date | moment.Moment | string): string =>
  moment(date).locale(moment.locale()).format(I18n.t('date.formats.month_year'));

export const formatTime = (dateTime: Date | moment.Moment | string): string =>
  moment.utc(dateTime).locale(moment.locale()).format(I18n.t('time.formats.moment'));

export const formatNumber = (nr = 0, options = {}): string => {
  const { precision, separator, delimiter } = {
    precision: I18n.t('number.format.precision'),
    separator: I18n.t('number.format.separator'),
    delimiter: I18n.t('number.format.delimiter'),
    ...options,
  };
  const matched = nr.toFixed(parseInt(precision, 10)).match(/(\d+)\.?(\d+)?/);
  if (!matched) {
    return '';
  }
  const [, int, fract] = matched;
  // RegExp is from here https://github.com/adamwdraper/Numeral-js/blob/c53250b1cb944868e67c3fec17829261e61fbb6b/numeral-with-locales.js#L203
  const delimitedInt = int.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${delimiter}`);
  return fract ? `${delimitedInt}${separator}${fract}` : delimitedInt;
};

export default {
  date: formatDate,
  dateMonthShort: formatDateMonthShort,
  time: formatTime,
  number: formatNumber,
};
